import React from 'react';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { Tooltip } from '@klp/design/Tooltip';
import type { Theme } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
import { useKostnadsKalkyleContext } from '../context/KostnadsKalkyleProvider';
import { useProsjektInvalidateTags } from '@klp/prosjekt/services/rtkApi';

const styles = (theme: Theme) => ({
    closeButton: {
        position: 'absolute',
        top: theme.spacing(2),
        right: theme.spacing(2),
    },
});
export const KostnadsKalkyleModalCloseButton: React.FC = () => {
    const classes = useKlpStyles({}, styles);

    const { toggleModal, isReadOnly } = useKostnadsKalkyleContext();
    const invalidateKostnadskalkyle = useProsjektInvalidateTags([
        'Kostnadskalkyle',
    ]);

    const handleClose = () => {
        if (!isReadOnly) {
            invalidateKostnadskalkyle();
        }

        toggleModal();
    };

    return (
        <div className={classes.closeButton}>
            <Tooltip translation="prosjekt.vurderingsskjema.close">
                <IconButton onClick={handleClose}>
                    <Illustration
                        icon={IconName.CLOSE}
                        klpPalette="primary"
                        klpColor="main"
                    />
                </IconButton>
            </Tooltip>
        </div>
    );
};
